<template>
    <MenuBase :hidden="props.hidden" 
        :tooltipPosition="props.tooltipPosition" :theme="props.theme" 
        :tooltipText="props.tooltipText"
        @menuClick="duplicate()">
        <DocumentDuplicateIcon class="size-6" />
    </MenuBase>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import MenuBase from '@/components/common/menus/MenuBase.vue';
import { DocumentDuplicateIcon } from '@heroicons/vue/24/outline';

const emit = defineEmits(['duplicate'])
const props = defineProps( {
    disabled: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top'
    },
    theme: {
        type: String,
        default: 'light'
    },
    tooltipText: {
        type: String,
        default: 'Download PDF'
    }
})

const duplicate = () => {
    emit('duplicate');
}
</script>